import FormEvidence from "./components/FormEvidence";
import { useStaffTimeControlCommand } from "./hooks/useStaffTimeControlCommand.js";

function RegisterStaffTimeControl() {
  const {
    staffTimeControl,
    createStaffTimeControl,
    errors: { errors },
    handleChange,
    loading,
  } = useStaffTimeControlCommand();

  const handleSubmit = (event) => {
    event.preventDefault();
    createStaffTimeControl();
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">
          Registrar control de horario del personal
        </h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro control de horario del personal.
              Asegúrate de completar todos los campos requeridos.
            </p>
            <FormEvidence
              data={staffTimeControl}
              onChange={handleChange}
              onSubmit={handleSubmit}
              errors={errors}
              loading={loading}
              typeFiles=".xlsx, .xls, .csv"
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterStaffTimeControl;